module.exports = __webpack_public_path__ + "gy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gy.svg
// module id = 590
// module chunks = 0